import { createAction, props } from '@ngrx/store';
import { ScheduleEditorProgress } from 'app/admin/schedules/schedules-editor/incremental-progress-schema';

export const loadIncrementalProgresses = createAction('[ScheduleEditor] Load IncrementalProgresses');
export const loadIncrementalProgressesSuccess = createAction(
	'[ScheduleEditor] Load IncrementalProgresses Success',
	props<{ progresses: ScheduleEditorProgress[] }>()
);
export const loadIncrementalProgressesFailure = createAction('[ScheduleEditor] Load IncrementalProgresses Failure', props<{ error: unknown }>());

export const createIncrementalProgress = createAction('[ScheduleEditor] Create IncrementalProgress', props<{ correlationId: string }>());
export const createIncrementalProgressSuccess = createAction(
	'[ScheduleEditor] Create IncrementalProgress Success',
	props<{ correlationId: string; progress: ScheduleEditorProgress }>()
);
export const createIncrementalProgressFailure = createAction(
	'[ScheduleEditor] Create IncrementalProgress Failure',
	props<{ correlationId: string; error: unknown }>()
);

export const updateIncrementalProgress = createAction(
	'[ScheduleEditor] Update IncrementalProgress',
	props<{ correlationId: string } & Pick<ScheduleEditorProgress, 'id' | 'data'>>()
);
export const updateIncrementalProgressSuccess = createAction(
	'[ScheduleEditor] Update IncrementalProgress Success',
	props<{ correlationId: string; progress: ScheduleEditorProgress }>()
);
export const updateIncrementalProgressFailure = createAction(
	'[ScheduleEditor] Update IncrementalProgress Failure',
	props<{ correlationId: string; error: unknown }>()
);

export const hydrateIncrementalProgresses = createAction('[ScheduleEditor] Hydrate IncrementalProgresses');
